module.exports = __webpack_public_path__ + "media/窗外的风景 (电影《我要我们在一起》配乐).d126efce.mp3";